import { render } from "./EApi.vue?vue&type=template&id=856a2046"
import script from "./EApi.vue?vue&type=script&lang=js"
export * from "./EApi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__